import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import useAxios from '../services/AxiosConfig';
import { showAlert } from './PerinHealthAlertSlice';
import styles from './ModalStyles.module.css'
import { setFormField } from '../slicers/PatientSlice';

const NotificationSettingsModal = ({ open, onClose }) => {

    const patientInfo = useSelector((state) => state.patient);
    const dispatch = useDispatch();
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);
    const userAccountId = useSelector((state) => state.userInfo.id);

    const [sendSMS, setSendSMS] = useState(patientInfo.userSettingsForPatient?.sendSMS ?? false);
    const [alertSilenced, setAlertSilenced] = useState(patientInfo.userSettingsForPatient?.alertSilenced ?? false);

    const updateSettings = async () => {
        if (
            Boolean(sendSMS) === Boolean(patientInfo.userSettingsForPatient?.sendSMS) &&
            Boolean(alertSilenced) === Boolean(patientInfo.userSettingsForPatient?.alertSilenced)
        ) {
        onClose();
        return;
        }
        const info = {
            "patientId": patientInfo.id,
            "sendSMS": sendSMS,
            "alertSilenced": alertSilenced
        };
        try {
            const response = await axios.request({
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                url: `careTeam/alert/notifications/${userAccountId}`,
                data: JSON.stringify(info),
            });
            if (response) {
                dispatch(
                    showAlert({
                        header: "Success",
                        message: `Updated settings`,
                        type: 'success'
                    })
                );
                if (Array.isArray(response.data.data)) {
                    dispatch(setFormField({ key: "userSettingsForPatient", value: response.data.data[0] }));
                }
            }

        } catch (error) {
            console.log("error:" + error);
            dispatch(
                showAlert({
                    header: "Error",
                    message: "Could not update settings",
                    type: 'danger',
                })
            );
        }
        onClose();
    };

    return (
        <Modal
            show={open}
            onHide={onClose}
            centered
        >
            <Modal.Header closeButton>
                <div className="subtitle-1">
                    Notification Settings
                </div>
            </Modal.Header>
            <Modal.Body>
                <Form style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <Form.Group>
                        <Form.Label className="body-2" style={{ marginBottom: "0" }}>Silence Alerts</Form.Label>
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            checked={alertSilenced}
                            onChange={(e) => setAlertSilenced(e.target.checked)}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label className="body-2" style={{ marginBottom: "0" }}>Send SMS</Form.Label>
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            checked={sendSMS}
                            onChange={(e) => setSendSMS(e.target.checked)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className={styles.SecondaryButton} variant="secondary" onClick={onClose}>
                    Close
                </Button>
                <Button className={styles.PrimaryButton} variant="primary" onClick={updateSettings}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default NotificationSettingsModal;